import { useState, useEffect, useRef, useCallback } from "react";

const API_BASE = "/api";
const TEST_USER = { email: "antonio@test.com", password: "test1234" };

// ── MeSH → Filtros (mapeo determinístico) ──────────────────────────────

const REGIONS = {
  traumatologia: [
    { id: "hombro", label: "Hombro", mesh: ["Shoulder Joint", "Shoulder Fractures", "Rotator Cuff", "Rotator Cuff Injuries", "Shoulder Dislocation", "Humeral Fractures, Proximal", "Acromioclavicular Joint"] },
    { id: "codo", label: "Codo", mesh: ["Elbow Joint", "Elbow", "Tennis Elbow", "Olecranon Process", "Radial Head", "Humeral Fractures, Distal"] },
    { id: "muneca-mano", label: "Muñeca-Mano", mesh: ["Wrist Fractures", "Radius Fractures", "Wrist Joint", "Carpal Bones", "Scaphoid Bone", "Metacarpal Bones", "Finger Injuries", "Fingers", "Palmar Plate", "Carpal Tunnel Syndrome", "Hand"] },
    { id: "rodilla", label: "Rodilla", mesh: ["Knee Joint", "Knee Prosthesis", "Arthroplasty, Replacement, Knee", "Osteoarthritis, Knee", "Patella", "Anterior Cruciate Ligament", "Anterior Cruciate Ligament Injuries", "Anterior Cruciate Ligament Reconstruction", "Posterior Cruciate Ligament", "Menisci, Tibial", "Patellar Ligament", "Femoral Fractures, Distal"] },
    { id: "tobillo-pie", label: "Tobillo-Pie", mesh: ["Ankle Joint", "Ankle Fractures", "Calcaneus", "Talus", "Achilles Tendon", "Foot", "Foot Diseases", "Metatarsal Bones", "Hallux Valgus", "Tibial Fractures", "Tibia", "Plantar Fasciitis", "Suture Techniques"] },
    { id: "cadera", label: "Cadera", mesh: ["Hip Joint", "Hip Fractures", "Hip Prosthesis", "Arthroplasty, Replacement, Hip", "Femoral Neck Fractures", "Femoral Fractures", "Femur", "Femur Head", "Femur Head Necrosis", "Acetabulum", "Femoracetabular Impingement", "Hemiarthroplasty", "Osteoarthritis, Hip"] },
    { id: "columna", label: "Columna", mesh: ["Spine", "Spinal Fusion", "Spinal Diseases", "Intervertebral Disc", "Intervertebral Disc Degeneration", "Lumbar Vertebrae", "Cervical Vertebrae", "Thoracic Vertebrae", "Scoliosis", "Spinal Stenosis", "Spondylolysis", "Spondylolisthesis", "Kyphosis"] },
    { id: "infantil", label: "Infantil", mesh: ["Child", "Child, Preschool", "Adolescent", "Osteogenesis Imperfecta", "Pediatrics", "Growth Plate"] },
    { id: "tumores", label: "Tumores", mesh: ["Bone Neoplasms", "Osteosarcoma", "Chondrosarcoma", "Sarcoma", "Neoplasm Metastasis"] },
  ],
  oftalmologia: [
    { id: "retina", label: "Retina", mesh: ["Diabetic Retinopathy", "Retinal Detachment", "Retinal Ganglion Cells", "Retinal Pigment Epithelium", "Retinitis Pigmentosa", "Macular Degeneration", "Macular Edema", "Wet Macular Degeneration", "Stargardt Disease", "Choroidal Neovascularization", "Retinal Vessels", "Retina", "Hypertensive Retinopathy", "Epiretinal Membrane"] },
    { id: "glaucoma", label: "Glaucoma", mesh: ["Glaucoma", "Glaucoma, Open-Angle", "Glaucoma, Angle-Closure", "Glaucoma Drainage Implants", "Trabeculectomy", "Trabecular Meshwork", "Filtering Surgery", "Intraocular Pressure", "Stents", "Latanoprost"] },
    { id: "cornea", label: "Córnea", mesh: ["Cornea", "Corneal Diseases", "Corneal Transplantation", "Descemet Stripping Endothelial Keratoplasty", "Endothelium, Corneal", "Keratoconus", "Corneal Dystrophies, Hereditary"] },
    { id: "cristalino", label: "Cristalino y catarata", mesh: ["Cataract", "Cataract Extraction", "Phacoemulsification", "Lenses, Intraocular", "Lens, Crystalline"] },
    { id: "superficie", label: "Superficie ocular", mesh: ["Dry Eye Syndromes", "Conjunctivitis", "Blepharitis", "Tears", "Conjunctiva", "Meibomian Glands"] },
    { id: "oculoplastica", label: "Oculoplástica", mesh: ["Eyelids", "Orbit", "Lacrimal Apparatus", "Ptosis", "Orbital Diseases"] },
    { id: "neuro", label: "Neuro-oftalmología", mesh: ["Optic Disk", "Optic Nerve Diseases", "Papilledema", "Nerve Fibers", "Optic Nerve", "Optic Neuritis"] },
    { id: "pediatrica", label: "Oft. pediátrica", mesh: ["Strabismus", "Amblyopia"] },
  ],
  anestesiologia: [
    { id: "general", label: "Anestesia general", mesh: ["Anesthesia, General", "Anesthetics, Intravenous", "Anesthetics, Inhalation", "Propofol", "Sevoflurane", "Desflurane", "Ketamine"] },
    { id: "regional", label: "Anestesia regional", mesh: ["Anesthesia, Spinal", "Anesthesia, Epidural", "Nerve Block", "Anesthesia, Local", "Brachial Plexus Block", "Fascia Iliaca Block", "Anesthetics, Local", "Bupivacaine", "Ropivacaine", "Lidocaine"] },
    { id: "via-aerea", label: "Vía aérea", mesh: ["Airway Management", "Intubation, Intratracheal", "Laryngeal Masks", "Laryngoscopy", "Tracheostomy", "Airway Obstruction", "Difficult Airway"] },
    { id: "dolor", label: "Dolor", mesh: ["Pain Management", "Pain, Postoperative", "Chronic Pain", "Analgesics, Opioid", "Analgesics", "Analgesia, Patient-Controlled", "Analgesia, Epidural", "Nociception"] },
    { id: "criticos", label: "Cuidados críticos", mesh: ["Critical Care", "Intensive Care Units", "Respiration, Artificial", "Hemodynamics", "Shock", "Sepsis", "Resuscitation", "Cardiopulmonary Resuscitation"] },
    { id: "cardiovascular", label: "Cardiovascular", mesh: ["Hemodynamic Monitoring", "Blood Pressure", "Hypotension", "Cardiac Output", "Fluid Therapy", "Vasoconstrictor Agents", "Vasodilator Agents"] },
    { id: "obstetrica", label: "Obstétrica", mesh: ["Anesthesia, Obstetrical", "Cesarean Section", "Labor, Obstetric", "Analgesia, Obstetrical"] },
    { id: "pediatrica", label: "Pediátrica", mesh: ["Anesthesia, Pediatric", "Child", "Infant", "Adolescent"] },
  ],
};

const PATHOLOGIES = {
  traumatologia: [
    { id: "fracturas", label: "Fracturas", mesh: ["Fractures, Bone", "Femoral Fractures", "Hip Fractures", "Wrist Fractures", "Radius Fractures", "Femoral Neck Fractures", "Tibial Fractures", "Femoral Fractures, Distal", "Fracture Fixation, Internal", "Fracture Fixation, Intramedullary", "Fracture Healing", "Open Fracture Reduction", "Closed Fracture Reduction", "Bone Nails", "Bone Plates", "Bone Screws", "Bone Wires"] },
    { id: "artroplastia", label: "Artroplastia", mesh: ["Arthroplasty, Replacement, Hip", "Arthroplasty, Replacement, Knee", "Hip Prosthesis", "Knee Prosthesis", "Hemiarthroplasty", "Prosthesis Design", "Prosthesis Failure"] },
    { id: "artroscopia", label: "Artroscopia", mesh: ["Arthroscopy", "Anterior Cruciate Ligament Reconstruction"] },
    { id: "ligamentos", label: "Ligamentos y tendones", mesh: ["Anterior Cruciate Ligament", "Anterior Cruciate Ligament Injuries", "Anterior Cruciate Ligament Reconstruction", "Posterior Cruciate Ligament", "Rotator Cuff Injuries", "Tendon Injuries", "Achilles Tendon"] },
    { id: "tecnologia", label: "Tecnología quirúrgica", mesh: ["Robotic Surgical Procedures", "Surgery, Computer-Assisted", "Machine Learning", "Deep Learning", "Biosensing Techniques", "Fluoroscopy", "Finite Element Analysis"] },
    { id: "complicaciones", label: "Complicaciones", mesh: ["Postoperative Complications", "Prosthesis Failure", "Treatment Failure", "Corrosion", "Postoperative Pain", "Chronic Pain", "Patient Readmission", "Reoperation", "Drainage"] },
    { id: "farmacologia", label: "Farmacología", mesh: ["Memantine", "Analgesics, Opioid", "Pain Management", "Anti-Bacterial Agents"] },
    { id: "rehabilitacion", label: "Rehabilitación", mesh: ["Range of Motion, Articular", "Postural Balance", "Weight-Bearing", "Braces", "Splints", "Physical Therapy Modalities"] },
  ],
  oftalmologia: [
    { id: "cirugia", label: "Cirugía", mesh: ["Filtering Surgery", "Trabeculectomy", "Cataract Extraction", "Phacoemulsification", "Corneal Transplantation", "Descemet Stripping Endothelial Keratoplasty", "Vitrectomy"] },
    { id: "farmacologia", label: "Farmacología", mesh: ["Bevacizumab", "Ranibizumab", "Latanoprost", "Intravitreal Injections", "Angiogenesis Inhibitors", "Lipoxins"] },
    { id: "diagnostico", label: "Diagnóstico", mesh: ["Tomography, Optical Coherence", "Image Processing, Computer-Assisted", "Deep Learning", "Machine Learning", "Visual Acuity", "Biomarkers"] },
    { id: "genetica", label: "Genética y terapia génica", mesh: ["Genetic Therapy", "Retinitis Pigmentosa", "Stargardt Disease", "Genome-Wide Association Study", "Corneal Dystrophies, Hereditary"] },
    { id: "refractiva", label: "Cirugía refractiva", mesh: ["Refractive Surgical Procedures", "Laser Therapy", "Myopia", "Astigmatism"] },
  ],
  anestesiologia: [
    { id: "farmacologia", label: "Farmacología", mesh: ["Anesthetics", "Anesthetics, Intravenous", "Anesthetics, Inhalation", "Anesthetics, Local", "Analgesics, Opioid", "Analgesics", "Propofol", "Ketamine", "Dexmedetomidine", "Neuromuscular Blocking Agents", "Sugammadex"] },
    { id: "monitorizacion", label: "Monitorización", mesh: ["Monitoring, Physiologic", "Hemodynamic Monitoring", "Pulse Oximetry", "Capnography", "Electroencephalography", "Depth of Anesthesia", "Blood Gas Analysis"] },
    { id: "tecnicas", label: "Técnicas", mesh: ["Nerve Block", "Ultrasonography, Interventional", "Intubation, Intratracheal", "Catheterization, Central Venous", "Catheterization, Peripheral"] },
    { id: "complicaciones", label: "Complicaciones", mesh: ["Anesthesia Recovery Period", "Postoperative Nausea and Vomiting", "Intraoperative Complications", "Postoperative Complications", "Anaphylaxis", "Malignant Hyperthermia", "Awareness During Anesthesia"] },
    { id: "perioperatorio", label: "Perioperatorio", mesh: ["Perioperative Care", "Preoperative Care", "Postoperative Care", "Enhanced Recovery After Surgery", "Risk Assessment", "Preoperative Period"] },
    { id: "seguridad", label: "Seguridad del paciente", mesh: ["Patient Safety", "Medical Errors", "Checklist", "Simulation Training", "Quality Improvement"] },
  ],
};

function matchPaper(paper, specialty) {
  const regions = REGIONS[specialty] || [];
  const pathologies = PATHOLOGIES[specialty] || [];
  const meshDescs = (paper.meshTerms || []).map((t) => t.descriptor || t);

  if (meshDescs.length === 0) return { regions: [], pathologies: [] };

  return {
    regions: regions.filter((r) => r.mesh.some((m) => meshDescs.includes(m))).map((r) => r.id),
    pathologies: pathologies.filter((p) => p.mesh.some((m) => meshDescs.includes(m))).map((p) => p.id),
  };
}

// ── Utility ────────────────────────────────────────────────────────────
const fmt = (s) => {
  if (!s) return "0:00";
  const m = Math.floor(s / 60);
  const sec = Math.floor(s % 60);
  return `${m}:${sec.toString().padStart(2, "0")}`;
};

const daysSince = (d) => {
  if (!d) return "";
  const diff = Date.now() - new Date(d).getTime();
  const days = Math.floor(diff / 86400000);
  if (days === 0) return "Hoy";
  if (days === 1) return "Ayer";
  if (days < 7) return `Hace ${days} días`;
  if (days < 30) return `Hace ${Math.floor(days / 7)} sem`;
  return new Date(d).toLocaleDateString("es-ES", { day: "numeric", month: "short" });
};

const getAuthors = (a) => (typeof a === "object" && a?.display ? a.display : a || "");

// ── Landing Page ───────────────────────────────────────────────────────
function Landing({ specialties, onSelect, paperCounts }) {
  const active = specialties.filter((s) => s.active);
  const coming = specialties.filter((s) => !s.active);

  return (
    <div style={styles.landing}>
      <div style={styles.landingGlow} />
      <div style={styles.landingContent}>
        <div style={styles.hero}>
          <div style={styles.heroLogo}>
            <svg width="44" height="44" viewBox="0 0 32 32" fill="none">
              <rect width="32" height="32" rx="8" fill="#1a1a2e" />
              <path d="M8 22V10l6 4v-4l6 4v-4l4 3v10H8z" fill="#4ecca3" />
            </svg>
          </div>
          <h1 style={styles.heroTitle}>MedUpdate</h1>
          <p style={styles.heroSub}>
            Resúmenes científicos en español con audio, puntuados por IA.
            <br />Selecciona tu especialidad.
          </p>
        </div>

        <div style={styles.gridLabel}>Especialidades activas</div>
        <div style={styles.specGrid}>
          {active.map((s, i) => (
            <button
              key={s.slug}
              onClick={() => onSelect(s.slug)}
              style={{ ...styles.specSquare, animationDelay: `${i * 0.06}s` }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-4px)";
                e.currentTarget.style.boxShadow = `0 12px 28px ${s.color}28`;
                e.currentTarget.style.borderColor = s.color;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.06)";
                e.currentTarget.style.borderColor = "#e8e8e6";
              }}
            >
              <div style={{ ...styles.sqIcon, background: `${s.color}15` }}>{s.icon}</div>
              <div style={styles.sqName}>{s.name}</div>
              <div style={styles.sqMeta}>{paperCounts[s.slug] || 0} artículos</div>
            </button>
          ))}
        </div>

        {coming.length > 0 && (
          <>
            <div style={{ ...styles.gridLabel, marginTop: 32 }}>Próximamente</div>
            <div style={styles.specGrid}>
              {coming.map((s, i) => (
                <div key={s.slug} style={{ ...styles.specSquare, ...styles.comingSquare, animationDelay: `${(active.length + i) * 0.04}s` }}>
                  <div style={{ ...styles.sqIcon, background: "rgba(255,255,255,0.06)" }}>{s.icon}</div>
                  <div style={{ ...styles.sqName, color: "#8b8fa3" }}>{s.name}</div>
                  <div style={styles.comingBadge}>Pronto</div>
                </div>
              ))}
            </div>
          </>
        )}

        <p style={styles.landingFooter}>PubMed + Cochrane → Claude scoring → resumen español → OpenAI TTS</p>
      </div>
    </div>
  );
}

// ── Audio Player ───────────────────────────────────────────────────────
function AudioPlayer({ paper, isPlaying, onToggle, progress, duration, onSeek, audioRef }) {
  if (!paper) return null;
  const pct = duration > 0 ? (progress / duration) * 100 : 0;

  return (
    <div style={styles.player}>
      <div style={styles.playerInner}>
        <button onClick={onToggle} style={styles.playBtn}>
          {isPlaying ? (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><rect x="6" y="4" width="4" height="16" /><rect x="14" y="4" width="4" height="16" /></svg>
          ) : (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><polygon points="5,3 19,12 5,21" /></svg>
          )}
        </button>
        <div style={styles.playerMeta}>
          <div style={styles.playerTitle}>{paper.title?.length > 70 ? paper.title.slice(0, 70) + "…" : paper.title}</div>
          <div style={styles.playerSub}>{getAuthors(paper.authors)}</div>
        </div>
        <div style={styles.playerTime}>{fmt(progress)} / {fmt(duration)}</div>
      </div>
      <div style={styles.seekBar} onClick={(e) => { const rect = e.currentTarget.getBoundingClientRect(); onSeek((e.clientX - rect.left) / rect.width); }}>
        <div style={{ ...styles.seekProgress, width: `${pct}%` }} />
      </div>
      <audio ref={audioRef} />
    </div>
  );
}

// ── Paper Card ──────────────────────────────────────────────────────────
function PaperCard({ paper, isActive, onPlay, specialtyColor, onLike, onSave }) {
  const score = paper.aiScore || 0;
  const scoreColor = score >= 9 ? "#16a34a" : score >= 7 ? "#ca8a04" : "#9ca3af";
  const tags = paper.subtopics || [];

  return (
    <div style={{ ...styles.card, borderLeft: `3px solid ${specialtyColor}`, ...(isActive ? { background: "rgba(43,122,120,0.06)", boxShadow: "0 2px 8px rgba(0,0,0,0.08)" } : {}) }}>
      <div style={styles.cardHeader}>
        <span style={{ ...styles.badge, background: (paper.source || "").toLowerCase() === "cochrane" ? "#7c3aed15" : "#2563eb12", color: (paper.source || "").toLowerCase() === "cochrane" ? "#7c3aed" : "#2563eb" }}>{paper.source}</span>
        {paper.evidenceLevel && <span style={styles.evidenceBadge}>{paper.evidenceLevel}</span>}
        <span style={{ ...styles.score, color: scoreColor }}>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" style={{ marginRight: 3, verticalAlign: -1 }}><path d="M12 2L9.19 8.63L2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61z" /></svg>
          {score}
        </span>
        <span style={styles.date}>{daysSince(paper.publicationDate)}</span>
      </div>
      <h3 style={styles.cardTitle}>{paper.title}</h3>
      <p style={styles.cardAuthors}>{getAuthors(paper.authors)} · <em>{paper.journal}</em></p>
      <p style={styles.cardSummary}>{paper.summary}</p>
      {paper.clinicalTakeaway && (
        <div style={styles.takeaway}><strong>Aplicación clínica:</strong> {paper.clinicalTakeaway}</div>
      )}
      <div style={styles.cardFooter}>
        <div style={styles.tags}>{tags.map((t) => <span key={t} style={styles.tag}>{t}</span>)}</div>
        <div style={styles.actions}>
          <button onClick={() => onLike(paper.id)} style={styles.actionBtn}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill={paper.userInteraction?.liked ? "#ef4444" : "none"} stroke={paper.userInteraction?.liked ? "#ef4444" : "#999"} strokeWidth="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" /></svg>
            <span style={{ fontSize: 11, color: "#999" }}>{paper.stats?.likes || 0}</span>
          </button>
          <button onClick={() => onSave(paper.id)} style={styles.actionBtn}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill={paper.userInteraction?.saved ? "#2563eb" : "none"} stroke={paper.userInteraction?.saved ? "#2563eb" : "#999"} strokeWidth="2"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" /></svg>
          </button>
          {(paper.stats?.comments > 0) && (
            <span style={{ fontSize: 11, color: "#999", display: "flex", alignItems: "center", gap: 3 }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#999" strokeWidth="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /></svg>
              {paper.stats.comments}
            </span>
          )}
          {paper.audioDuration > 0 && (
            <button onClick={() => onPlay(paper)} style={{ ...styles.listenBtn, background: specialtyColor }}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor" style={{ marginRight: 5 }}><polygon points="5,3 19,12 5,21" /></svg>
              {fmt(paper.audioDuration)}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

// ── Feed View ───────────────────────────────────────────────────────────
function FeedView({
  specialty, specialties, papers, loading, sort, setSort, search, setSearch,
  currentPaper, onPlay, onLike, onSave, onBack, regionFilter, setRegionFilter,
  pathologyFilter, setPathologyFilter,
}) {
  const spec = specialties.find((s) => s.slug === specialty);
  const specColor = spec?.color || "#555";
  const currentRegions = REGIONS[specialty] || [];
  const currentPathologies = PATHOLOGIES[specialty] || [];

  const taggedPapers = papers.map((p) => ({ ...p, _match: matchPaper(p, specialty) }));

  // Count per region
  const regionCounts = {};
  currentRegions.forEach((r) => {
    regionCounts[r.id] = taggedPapers.filter((p) => p._match.regions.includes(r.id)).length;
  });

  // Count per pathology (within selected region or all)
  const pathologyCounts = {};
  const regionFiltered = regionFilter ? taggedPapers.filter((p) => p._match.regions.includes(regionFilter)) : taggedPapers;
  currentPathologies.forEach((pt) => {
    pathologyCounts[pt.id] = regionFiltered.filter((p) => p._match.pathologies.includes(pt.id)).length;
  });

  // Apply all filters
  const filtered = taggedPapers.filter((p) => {
    const matchSearch = !search ||
      p.title?.toLowerCase().includes(search.toLowerCase()) ||
      (p.subtopics || []).some((t) => t.toLowerCase().includes(search.toLowerCase())) ||
      p.journal?.toLowerCase().includes(search.toLowerCase()) ||
      getAuthors(p.authors)?.toLowerCase().includes(search.toLowerCase());
    const matchRegion = !regionFilter || p._match.regions.includes(regionFilter);
    const matchPath = !pathologyFilter || p._match.pathologies.includes(pathologyFilter);
    return matchSearch && matchRegion && matchPath;
  });

  return (
    <div style={styles.feedRoot}>
      <header style={styles.header}>
        <div style={styles.headerInner}>
          <button onClick={onBack} style={styles.backBtn}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#4ecca3" strokeWidth="2"><polyline points="15 18 9 12 15 6" /></svg>
          </button>
          <div style={styles.logo}>
            <svg width="24" height="24" viewBox="0 0 32 32" fill="none"><rect width="32" height="32" rx="8" fill="#1a1a2e" /><path d="M8 22V10l6 4v-4l6 4v-4l4 3v10H8z" fill="#4ecca3" /></svg>
            <span style={styles.logoText}>MedUpdate</span>
          </div>
          <div style={{ ...styles.headerSpec, color: specColor }}><span style={{ marginRight: 4 }}>{spec?.icon}</span>{spec?.name}</div>
        </div>
      </header>

      <main style={styles.main}>
        <div style={styles.toolbar}>
          <div style={styles.searchWrap}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#aaa" strokeWidth="2" style={{ position: "absolute", left: 12, top: 12 }}><circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></svg>
            <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Buscar por título, autor, revista..." style={styles.searchInput} />
          </div>
          <select value={sort} onChange={(e) => setSort(e.target.value)} style={styles.sortSelect}>
            <option value="ai_score">Relevancia IA</option>
            <option value="date">Más recientes</option>
          </select>
        </div>

        {/* Region filters */}
        {currentRegions.length > 0 && (
          <div style={styles.filterSection}>
            <div style={styles.filterLabel}>Localización</div>
            <div style={styles.chipBar}>
              <button onClick={() => { setRegionFilter(null); setPathologyFilter(null); }} style={{ ...styles.chip, ...(regionFilter === null ? { background: specColor, color: "#fff", borderColor: specColor } : {}) }}>
                Todas ({taggedPapers.length})
              </button>
              {currentRegions.map((r) => (
                <button key={r.id} onClick={() => { setRegionFilter(regionFilter === r.id ? null : r.id); setPathologyFilter(null); }}
                  style={{ ...styles.chip, ...(regionFilter === r.id ? { background: specColor, color: "#fff", borderColor: specColor } : {}), ...(regionCounts[r.id] === 0 && regionFilter !== r.id ? { opacity: 0.45 } : {}) }}>
                  {r.label} ({regionCounts[r.id] || 0})
                </button>
              ))}
            </div>
          </div>
        )}

        {/* Pathology filters */}
        {currentPathologies.length > 0 && (
          <div style={styles.filterSection}>
            <div style={styles.filterLabel}>Tipo</div>
            <div style={styles.chipBar}>
              <button onClick={() => setPathologyFilter(null)} style={{ ...styles.chipSmall, ...(pathologyFilter === null ? { background: `${specColor}18`, color: specColor, borderColor: specColor } : {}) }}>
                Todos
              </button>
              {currentPathologies.map((pt) => (
                <button key={pt.id} onClick={() => setPathologyFilter(pathologyFilter === pt.id ? null : pt.id)}
                  style={{ ...styles.chipSmall, ...(pathologyFilter === pt.id ? { background: `${specColor}18`, color: specColor, borderColor: specColor } : {}), ...(pathologyCounts[pt.id] === 0 && pathologyFilter !== pt.id ? { opacity: 0.45 } : {}) }}>
                  {pt.label} ({pathologyCounts[pt.id] || 0})
                </button>
              ))}
            </div>
          </div>
        )}

        <div style={styles.stats}>
          <span style={{ color: specColor, fontWeight: 600 }}>{filtered.length}</span> artículos
          {regionFilter && <> en <strong>{currentRegions.find((r) => r.id === regionFilter)?.label}</strong></>}
          {pathologyFilter && <> · <strong>{currentPathologies.find((p) => p.id === pathologyFilter)?.label}</strong></>}
          {filtered.length > 0 && (
            <> · score medio <span style={{ fontWeight: 600 }}>{(filtered.reduce((a, b) => a + (b.aiScore || 0), 0) / filtered.length).toFixed(1)}</span></>
          )}
        </div>

        {loading ? (
          <div style={styles.loadingWrap}><div style={styles.spinner} /><p style={{ color: "#888", marginTop: 12 }}>Cargando artículos...</p></div>
        ) : (
          <div style={styles.feed}>
            {filtered.map((p) => (
              <PaperCard key={p.id} paper={p} isActive={currentPaper?.id === p.id} onPlay={onPlay} onLike={onLike} onSave={onSave} specialtyColor={specColor} />
            ))}
            {filtered.length === 0 && (
              <div style={styles.empty}>{search || regionFilter || pathologyFilter ? "No hay artículos que coincidan con los filtros." : "No hay artículos disponibles."}</div>
            )}
          </div>
        )}
      </main>
    </div>
  );
}

// ── Main App ────────────────────────────────────────────────────────────
export default function MedUpdate() {
  const [token, setToken] = useState(null);
  const [specialties, setSpecialties] = useState([]);
  const [view, setView] = useState("landing");
  const [specialty, setSpecialty] = useState(null);
  const [papers, setPapers] = useState([]);
  const [paperCounts, setPaperCounts] = useState({});
  const [loading, setLoading] = useState(false);
  const [sort, setSort] = useState("ai_score");
  const [search, setSearch] = useState("");
  const [regionFilter, setRegionFilter] = useState(null);
  const [pathologyFilter, setPathologyFilter] = useState(null);

  const [currentPaper, setCurrentPaper] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [duration, setDuration] = useState(0);
  const audioRef = useRef(null);
  const mockTimerRef = useRef(null);

  useEffect(() => {
    fetch(`${API_BASE}/auth/login`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(TEST_USER) })
      .then((r) => r.json()).then((data) => { if (data.token) setToken(data.token); }).catch((err) => console.error('AUDIO ERROR:', err));
  }, []);

  useEffect(() => {
    fetch(`${API_BASE}/specialties`).then((r) => r.json()).then((data) => {
      if (Array.isArray(data) && data.length) setSpecialties(data.map((s) => ({ ...s, icon: s.icon || "📋", color: s.color || "#555" })));
    }).catch((err) => console.error('AUDIO ERROR:', err));
  }, []);

  useEffect(() => {
    if (!token || !specialties.length) return;
    specialties.filter((s) => s.active).forEach((s) => {
      fetch(`${API_BASE}/papers?specialty=${s.slug}&limit=100`, { headers: { Authorization: `Bearer ${token}` } })
        .then((r) => r.json()).then((data) => { setPaperCounts((prev) => ({ ...prev, [s.slug]: data.papers?.length || 0 })); }).catch((err) => console.error('AUDIO ERROR:', err));
    });
  }, [token, specialties]);

  useEffect(() => {
    if (!token || !specialty) return;
    setLoading(true);
    fetch(`${API_BASE}/papers?specialty=${specialty}&sort=${sort}&limit=100`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.json()).then((data) => { if (data.papers) { setPapers(data.papers); setPaperCounts((prev) => ({ ...prev, [specialty]: data.papers.length })); } })
      .catch(() => setPapers([])).finally(() => setLoading(false));
  }, [token, specialty, sort]);

  const handleSelectSpecialty = (slug) => { setSpecialty(slug); setSearch(""); setRegionFilter(null); setPathologyFilter(null); setView("feed"); };
  const handleBack = () => { setView("landing"); setSpecialty(null); setSearch(""); setRegionFilter(null); setPathologyFilter(null); };

  const handlePlay = useCallback((paper) => {
    if (currentPaper?.id === paper.id) { setIsPlaying((p) => !p); return; }
    console.log("PLAY:", paper.audioUrl, "TOKEN:", !!token, "REF:", !!audioRef.current); setCurrentPaper(paper); setProgress(0); setDuration(paper.audioDuration || 0); setIsPlaying(true);
    // audio loading handled by useEffect
  }, [currentPaper, token]);

  // Load audio when currentPaper changes
  useEffect(() => {
    if (!currentPaper?.audioUrl || !token) return;
    const a = audioRef.current;
    if (!a) return;
    fetch(`${currentPaper.audioUrl}`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.blob())
      .then(blob => {
        if (a._blobUrl) URL.revokeObjectURL(a._blobUrl);
        a._blobUrl = URL.createObjectURL(blob);
        a.src = a._blobUrl;
        a.load();
        a.play().catch(() => {});
      }).catch((err) => console.error('AUDIO ERROR:', err));
  }, [currentPaper, token]);

  useEffect(() => {
    const a = audioRef.current; if (!a) return;
    const onT = () => setProgress(a.currentTime); const onD = () => setDuration(a.duration); const onE = () => { setIsPlaying(false); setProgress(0); };
    a.addEventListener("timeupdate", onT); a.addEventListener("loadedmetadata", onD); a.addEventListener("ended", onE);
    return () => { a.removeEventListener("timeupdate", onT); a.removeEventListener("loadedmetadata", onD); a.removeEventListener("ended", onE); };
  }, []);

  useEffect(() => {
    const a = audioRef.current; if (!currentPaper) return;
    if (currentPaper.audioUrl && token && a) { if (isPlaying) a.play().catch(() => {}); else a.pause(); }
    else { if (mockTimerRef.current) clearInterval(mockTimerRef.current); if (isPlaying) { mockTimerRef.current = setInterval(() => { setProgress((p) => { if (p >= (currentPaper.audioDuration || 180)) { setIsPlaying(false); clearInterval(mockTimerRef.current); return 0; } return p + 1; }); }, 1000); } }
    return () => { if (mockTimerRef.current) clearInterval(mockTimerRef.current); };
  }, [isPlaying, currentPaper, token]);

  const handleSeek = (pct) => { const t = pct * (duration || currentPaper?.audioDuration || 180); setProgress(t); if (audioRef.current && currentPaper?.audioUrl && token) audioRef.current.currentTime = t; };

  const handleLike = async (id) => {
    if (!token) return;
    try { const r = await fetch(`${API_BASE}/papers/${id}/like`, { method: "POST", headers: { Authorization: `Bearer ${token}` } }); const d = await r.json();
      setPapers((prev) => prev.map((p) => p.id === id ? { ...p, userInteraction: { ...p.userInteraction, liked: d.liked }, stats: { ...p.stats, likes: d.totalLikes } } : p));
    } catch (e) { console.error(e); }
  };

  const handleSave = async (id) => {
    if (!token) return;
    try { const r = await fetch(`${API_BASE}/papers/${id}/save`, { method: "POST", headers: { Authorization: `Bearer ${token}` } }); const d = await r.json();
      setPapers((prev) => prev.map((p) => p.id === id ? { ...p, userInteraction: { ...p.userInteraction, saved: d.saved } } : p));
    } catch (e) { console.error(e); }
  };

  return (
    <div style={styles.root}>
      <style>{`@keyframes fadeUp{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:translateY(0)}}@keyframes spin{to{transform:rotate(360deg)}}`}</style>
      {view === "landing" ? (
        <Landing specialties={specialties} onSelect={handleSelectSpecialty} paperCounts={paperCounts} />
      ) : (
        <FeedView specialty={specialty} specialties={specialties} papers={papers} loading={loading}
          sort={sort} setSort={setSort} search={search} setSearch={setSearch} currentPaper={currentPaper}
          onPlay={handlePlay} onLike={handleLike} onSave={handleSave} onBack={handleBack}
          regionFilter={regionFilter} setRegionFilter={setRegionFilter}
          pathologyFilter={pathologyFilter} setPathologyFilter={setPathologyFilter} />
      )}
      <audio ref={audioRef} style={{display:"none"}} />
      <AudioPlayer paper={currentPaper} isPlaying={isPlaying} onToggle={() => setIsPlaying((p) => !p)}
        progress={progress} duration={duration || currentPaper?.audioDuration || 0} onSeek={handleSeek} audioRef={audioRef} />
    </div>
  );
}

// ── Styles ──────────────────────────────────────────────────────────────
const styles = {
  root: { fontFamily: "'IBM Plex Sans', 'Segoe UI', system-ui, sans-serif", minHeight: "100vh", color: "#1a1a2e" },
  landing: { minHeight: "100vh", background: "linear-gradient(160deg, #0f0f1e 0%, #1a1a2e 40%, #1e2a35 100%)", display: "flex", flexDirection: "column", alignItems: "center", position: "relative", overflow: "hidden", padding: "40px 20px" },
  landingGlow: { position: "absolute", width: 500, height: 500, borderRadius: "50%", background: "radial-gradient(circle, rgba(78,204,163,0.12) 0%, transparent 70%)", top: "5%", left: "50%", transform: "translateX(-50%)", pointerEvents: "none" },
  landingContent: { position: "relative", zIndex: 1, maxWidth: 560, width: "100%" },
  hero: { textAlign: "center", marginBottom: 32 },
  heroLogo: { display: "flex", justifyContent: "center", marginBottom: 16 },
  heroTitle: { fontSize: 38, fontWeight: 800, color: "#4ecca3", margin: "0 0 12px", letterSpacing: "-1px" },
  heroSub: { fontSize: 15, color: "#8b8fa3", lineHeight: 1.6, margin: 0 },
  gridLabel: { fontSize: 12, fontWeight: 700, color: "#4ecca3", textTransform: "uppercase", letterSpacing: "1px", marginBottom: 10 },
  specGrid: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 },
  specSquare: { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 8, padding: "22px 14px", background: "#fff", borderRadius: 14, border: "1.5px solid #e8e8e6", cursor: "pointer", transition: "all 0.25s ease", boxShadow: "0 2px 8px rgba(0,0,0,0.06)", textAlign: "center", animation: "fadeUp 0.4s ease both" },
  comingSquare: { background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)", cursor: "default" },
  sqIcon: { width: 48, height: 48, borderRadius: 12, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 24 },
  sqName: { fontSize: 14, fontWeight: 600, color: "#1a1a2e", lineHeight: 1.3 },
  sqMeta: { fontSize: 12, color: "#888" },
  comingBadge: { fontSize: 10, color: "#4ecca3", background: "rgba(78,204,163,0.12)", padding: "2px 8px", borderRadius: 10, fontWeight: 600 },
  landingFooter: { textAlign: "center", fontSize: 12, color: "#555", marginTop: 40, lineHeight: 1.5 },
  feedRoot: { background: "#f7f7f5", minHeight: "100vh", paddingBottom: 90 },
  header: { background: "#1a1a2e", padding: "12px 20px", position: "sticky", top: 0, zIndex: 100 },
  headerInner: { maxWidth: 720, margin: "0 auto", display: "flex", alignItems: "center", gap: 12 },
  backBtn: { background: "none", border: "none", cursor: "pointer", padding: 4, display: "flex", alignItems: "center" },
  logo: { display: "flex", alignItems: "center", gap: 8 },
  logoText: { color: "#4ecca3", fontSize: 17, fontWeight: 700, letterSpacing: "-0.5px" },
  headerSpec: { marginLeft: "auto", fontSize: 13, fontWeight: 600, display: "flex", alignItems: "center" },
  main: { maxWidth: 720, margin: "0 auto", padding: "0 16px" },
  toolbar: { display: "flex", gap: 10, alignItems: "center", paddingTop: 16, marginBottom: 8 },
  searchWrap: { position: "relative", flex: 1 },
  searchInput: { width: "100%", padding: "10px 12px 10px 36px", borderRadius: 10, border: "1.5px solid #e0e0e0", fontSize: 14, background: "#fff", outline: "none", boxSizing: "border-box" },
  sortSelect: { padding: "10px 12px", borderRadius: 10, border: "1.5px solid #e0e0e0", fontSize: 13, background: "#fff", color: "#555", cursor: "pointer", outline: "none", minWidth: 130 },
  filterSection: { marginBottom: 6 },
  filterLabel: { fontSize: 11, fontWeight: 700, color: "#999", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 6 },
  chipBar: { display: "flex", gap: 6, flexWrap: "wrap", paddingBottom: 4 },
  chip: { padding: "6px 14px", borderRadius: 20, border: "1.5px solid #ddd", background: "#fff", fontSize: 13, color: "#555", cursor: "pointer", whiteSpace: "nowrap", transition: "all 0.2s", fontWeight: 500 },
  chipSmall: { padding: "4px 11px", borderRadius: 16, border: "1.5px solid #e0e0e0", background: "#fff", fontSize: 12, color: "#666", cursor: "pointer", whiteSpace: "nowrap", transition: "all 0.2s" },
  stats: { fontSize: 13, color: "#888", padding: "8px 0 12px" },
  feed: { display: "flex", flexDirection: "column", gap: 12 },
  card: { background: "#fff", borderRadius: 12, padding: 18, boxShadow: "0 1px 3px rgba(0,0,0,0.06)", transition: "all .2s" },
  cardHeader: { display: "flex", alignItems: "center", gap: 8, marginBottom: 8, flexWrap: "wrap" },
  badge: { fontSize: 11, fontWeight: 700, padding: "2px 8px", borderRadius: 6, letterSpacing: "0.3px" },
  evidenceBadge: { fontSize: 10, fontWeight: 600, padding: "2px 6px", borderRadius: 4, background: "#f0f0ee", color: "#666", textTransform: "uppercase" },
  score: { fontSize: 13, fontWeight: 700, display: "flex", alignItems: "center" },
  date: { fontSize: 12, color: "#aaa", marginLeft: "auto" },
  cardTitle: { fontSize: 15, fontWeight: 600, lineHeight: 1.4, margin: "0 0 6px" },
  cardAuthors: { fontSize: 12.5, color: "#777", margin: "0 0 10px" },
  cardSummary: { fontSize: 13.5, lineHeight: 1.65, color: "#444", margin: "0 0 10px" },
  takeaway: { fontSize: 13, lineHeight: 1.5, color: "#1a5f3a", background: "#ecfdf5", padding: "8px 12px", borderRadius: 8, margin: "0 0 12px", borderLeft: "3px solid #22c55e" },
  cardFooter: { display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 8 },
  tags: { display: "flex", gap: 6, flexWrap: "wrap" },
  tag: { fontSize: 11, color: "#666", background: "#f0f0ee", padding: "2px 8px", borderRadius: 6 },
  actions: { display: "flex", alignItems: "center", gap: 10 },
  actionBtn: { background: "none", border: "none", cursor: "pointer", padding: 4, display: "flex", alignItems: "center", gap: 3 },
  listenBtn: { display: "flex", alignItems: "center", color: "#fff", border: "none", borderRadius: 20, padding: "6px 14px", fontSize: 13, fontWeight: 600, cursor: "pointer" },
  player: { position: "fixed", bottom: 0, left: 0, right: 0, background: "#1a1a2e", zIndex: 200, boxShadow: "0 -2px 20px rgba(0,0,0,0.15)" },
  playerInner: { maxWidth: 720, margin: "0 auto", display: "flex", alignItems: "center", gap: 12, padding: "10px 16px 4px" },
  playBtn: { width: 40, height: 40, borderRadius: "50%", border: "none", background: "#4ecca3", color: "#1a1a2e", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
  playerMeta: { flex: 1, overflow: "hidden" },
  playerTitle: { color: "#eee", fontSize: 13, fontWeight: 600, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" },
  playerSub: { color: "#888", fontSize: 11 },
  playerTime: { color: "#4ecca3", fontSize: 12, fontWeight: 600, flexShrink: 0 },
  seekBar: { height: 3, background: "#333", cursor: "pointer", marginTop: 4 },
  seekProgress: { height: "100%", background: "#4ecca3", transition: "width .3s linear" },
  empty: { textAlign: "center", padding: 40, color: "#aaa", fontSize: 14 },
  loadingWrap: { textAlign: "center", padding: 60 },
  spinner: { width: 32, height: 32, border: "3px solid #e0e0e0", borderTopColor: "#4ecca3", borderRadius: "50%", animation: "spin 0.8s linear infinite", margin: "0 auto" },
};
